import { render, staticRenderFns } from "./LocalMediaControls.vue?vue&type=template&id=18554918&scoped=true&"
import script from "./LocalMediaControls.vue?vue&type=script&lang=js&"
export * from "./LocalMediaControls.vue?vue&type=script&lang=js&"
import style0 from "./LocalMediaControls.vue?vue&type=style&index=0&id=18554918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18554918",
  null
  
)

export default component.exports